import React from "react";
import { SectionContainerImage } from "../common/sections/SectionContainerImage";
import Link from "next/link";

export const SectionAboutOurCompany: React.FC = () => {
  return (
    <SectionContainerImage id="about-us" additionalClassName="p-0 overflow-hidden !py-0 !my-0">
      <div
        className="relative bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url("/img/bg-about-company.png")' }}
      >
        <div className="absolute inset-0"   style={{ backgroundColor: 'rgba(33, 47, 66, 0.85)' }}/>
        <div className="relative z-10 container mx-auto px-4 flex flex-col md:flex-row items-start py-8 gap-6 text-white">
          <div className="md:w-1/2">
            <img src="/img/about-company.png" alt="Tentang Kami" className="rounded-lg shadow-lg"/>
          </div>
          <div className="md:w-1/2">
            <h2 className="text-2xl md:text-5xl font-bold mb-4 text-[#0D9488]">
              Tentang Perusahaan Kami
            </h2>
            <p className="text-white text-base md:text-xl font-semibold leading-relaxed mb-6 max-w-2xl" style={{ textAlign: 'justify' }}>
              PT Accelist Edukasi Indonesia merupakan bagian dari PT Accelist Lentera Indonesia yang sudah berdiri sejak tahun 2012 juga telah mendukung kemajuan industri digital melalui 7 batch training dan perekrutan karyawan tetap. Kami menyediakan program-program yang dapat diikuti oleh mahasiswa ataupun kalangan lainnya untuk menambah kemampuan ilmu Teknik Informatika sehingga akan melahirkan talenta digital yang berkualitas dan berkompeten untuk memenuhi kebutuhan tenaga kerja IT di Indonesia.            </p>
            <Link href="/tentang-kami" className="inline-block text-sm md:text-lg bg-[#0D9488] font-semibold px-8 md:px-12 py-3 rounded-lg shadow-md hover:bg-[#FFFFFF] hover:text-[#0D9488] transition">
              Lihat Detail
            </Link>
          </div>
        </div>
      </div>
    </SectionContainerImage>
  );
};